import * as api from '../api/models';
import * as pricingTableApi from '../api/pricingTable';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const FETCH_ADJUSTMENTS = createRequestTypes(
  `${prefix}/FETCH_ADJUSTMENTS`,
);

export const fetchAdjustments = makeApiActionCreatorV3(
  api.fetchAdjustments,
  FETCH_ADJUSTMENTS[START],
  FETCH_ADJUSTMENTS[SUCCESS],
  FETCH_ADJUSTMENTS[ERROR],
);

export const INSERT_ADJUSTMENT = createRequestTypes(
  `${prefix}/INSERT_ADJUSTMENT`,
);

export const insertAdjustment = makeApiActionCreatorV3(
  api.insertAdjustment,
  INSERT_ADJUSTMENT[START],
  INSERT_ADJUSTMENT[SUCCESS],
  INSERT_ADJUSTMENT[ERROR],
);

export const UPDATE_ADJUSTMENT = createRequestTypes(
  `${prefix}/UPDATE_ADJUSTMENT`,
);

export const updateAdjustment = makeApiActionCreatorV3(
  api.updateAdjustment,
  UPDATE_ADJUSTMENT[START],
  UPDATE_ADJUSTMENT[SUCCESS],
  UPDATE_ADJUSTMENT[ERROR],
);

export const DELETE_ADJUSTMENTS = createRequestTypes(
  `${prefix}/DELETE_ADJUSTMENTS`,
);

export const deleteAdjustments = makeApiActionCreatorV3(
  api.deleteAdjustments,
  DELETE_ADJUSTMENTS[START],
  DELETE_ADJUSTMENTS[SUCCESS],
  DELETE_ADJUSTMENTS[ERROR],
);

export const FETCH_FEATURES = createRequestTypes(`${prefix}/FETCH_FEATURES`);

export const fetchFeatures = makeApiActionCreatorV3(
  api.fetchFeatures,
  FETCH_FEATURES[START],
  FETCH_FEATURES[SUCCESS],
  FETCH_FEATURES[ERROR],
);

export const FETCH_MODEL_FEATURES = createRequestTypes(
  `${prefix}/FETCH_MODEL_FEATURES`,
);

export const fetchModelFeatures = makeApiActionCreatorV3(
  api.fetchModelFeatures,
  FETCH_MODEL_FEATURES[START],
  FETCH_MODEL_FEATURES[SUCCESS],
  FETCH_MODEL_FEATURES[ERROR],
);

export const INSERT_FEATURE = createRequestTypes(`${prefix}/INSERT_FEATURE`);

export const insertFeature = makeApiActionCreatorV3(
  api.insertFeature,
  INSERT_FEATURE[START],
  INSERT_FEATURE[SUCCESS],
  INSERT_FEATURE[ERROR],
);

export const INSERT_MODEL_FEATURE = createRequestTypes(
  `${prefix}/INSERT_MODEL_FEATURE`,
);

export const insertModelFeature = makeApiActionCreatorV3(
  api.insertModelFeature,
  INSERT_MODEL_FEATURE[START],
  INSERT_MODEL_FEATURE[SUCCESS],
  INSERT_MODEL_FEATURE[ERROR],
);

export const UPDATE_FEATURE_CODE = createRequestTypes(
  `${prefix}/UPDATE_FEATURE_CODE`,
);

export const updateFeatureCode = makeApiActionCreatorV3(
  api.updateFeatureCode,
  UPDATE_FEATURE_CODE[START],
  UPDATE_FEATURE_CODE[SUCCESS],
  UPDATE_FEATURE_CODE[ERROR],
);

export const DELETE_FEATURE = createRequestTypes(`${prefix}/DELETE_FEATURE`);

export const deleteFeature = makeApiActionCreatorV3(
  api.deleteFeature,
  DELETE_FEATURE[START],
  DELETE_FEATURE[SUCCESS],
  DELETE_FEATURE[ERROR],
);

export const DELETE_MODEL_FEATURE = createRequestTypes(
  `${prefix}/DELETE_MODEL_FEATURE`,
);

export const deleteModelFeature = makeApiActionCreatorV3(
  api.deleteModelFeature,
  DELETE_MODEL_FEATURE[START],
  DELETE_MODEL_FEATURE[SUCCESS],
  DELETE_MODEL_FEATURE[ERROR],
);

export const FETCH_TYPES = createRequestTypes(`${prefix}/FETCH_TYPES`);

export const fetchTypes = makeApiActionCreatorV3(
  api.fetchTypes,
  FETCH_TYPES[START],
  FETCH_TYPES[SUCCESS],
  FETCH_TYPES[ERROR],
);

export const FETCH_FEATURE_TYPES = createRequestTypes(
  `${prefix}/FETCH_FEATURE_TYPES`,
);

export const fetchFeatureTypes = makeApiActionCreatorV3(
  api.fetchFeatureTypes,
  FETCH_FEATURE_TYPES[START],
  FETCH_FEATURE_TYPES[SUCCESS],
  FETCH_FEATURE_TYPES[ERROR],
);

export const FETCH_FEATURE_CODES = createRequestTypes(
  `${prefix}/FETCH_FEATURE_CODES`,
);

export const fetchFeatureCodes = makeApiActionCreatorV3(
  api.fetchFeatureCodes,
  FETCH_FEATURE_CODES[START],
  FETCH_FEATURE_CODES[SUCCESS],
  FETCH_FEATURE_CODES[ERROR],
);

export const DELETE_FEATURE_CODE = createRequestTypes(
  `${prefix}/DELETE_FEATURE_CODE`,
);

export const deleteFeatureCode = makeApiActionCreatorV3(
  api.deleteFeatureCode,
  DELETE_FEATURE_CODE[START],
  DELETE_FEATURE_CODE[SUCCESS],
  DELETE_FEATURE_CODE[ERROR],
);

export const INSERT_FEATURE_CODE = createRequestTypes(
  `${prefix}/INSERT_FEATURE_CODE`,
);

export const insertFeatureCode = makeApiActionCreatorV3(
  api.insertFeatureCode,
  INSERT_FEATURE_CODE[START],
  INSERT_FEATURE_CODE[SUCCESS],
  INSERT_FEATURE_CODE[ERROR],
);

export const FETCH_AREA_TYPES = createRequestTypes(
  `${prefix}/FETCH_AREA_TYPES`,
);

export const fetchAreaTypes = makeApiActionCreatorV3(
  api.fetchAreaTypes,
  FETCH_AREA_TYPES[START],
  FETCH_AREA_TYPES[SUCCESS],
  FETCH_AREA_TYPES[ERROR],
);

export const FETCH_CODEFILE = createRequestTypes(`${prefix}/FETCH_CODEFILE`);

export const fetchCodefile = makeApiActionCreatorV3(
  api.fetchCodefile,
  FETCH_CODEFILE[START],
  FETCH_CODEFILE[SUCCESS],
  FETCH_CODEFILE[ERROR],
);

export const FETCH_PRICING_COMPONENTS = createRequestTypes(
  `${prefix}/FETCH_PRICING_COMPONENTS`,
);

export const fetchPricingComponents = makeApiActionCreatorV3(
  api.fetchPricingComponents,
  FETCH_PRICING_COMPONENTS[START],
  FETCH_PRICING_COMPONENTS[SUCCESS],
  FETCH_PRICING_COMPONENTS[ERROR],
);

export const DELETE_PRICING_COMPONENTS = createRequestTypes(
  `${prefix}/DELETE_PRICING_COMPONENTS`,
);

export const deletePricingComponents = makeApiActionCreatorV3(
  api.deletePricingComponents,
  DELETE_PRICING_COMPONENTS[START],
  DELETE_PRICING_COMPONENTS[SUCCESS],
  DELETE_PRICING_COMPONENTS[ERROR],
);

export const SET_AS_BASE_COMPONENT = createRequestTypes(
  `${prefix}/SET_AS_BASE_COMPONENT`,
);

export const setAsBase = makeApiActionCreatorV3(
  api.setAsBase,
  SET_AS_BASE_COMPONENT[START],
  SET_AS_BASE_COMPONENT[SUCCESS],
  SET_AS_BASE_COMPONENT[ERROR],
);

export const INSERT_PRICING_COMPONENTS = createRequestTypes(
  `${prefix}/INSERT_PRICING_COMPONENTS`,
);

export const insertPricingComponents = makeApiActionCreatorV3(
  api.insertPricingComponents,
  INSERT_PRICING_COMPONENTS[START],
  INSERT_PRICING_COMPONENTS[SUCCESS],
  INSERT_PRICING_COMPONENTS[ERROR],
);

export const UPDATE_PRICING_COMPONENTS = createRequestTypes(
  `${prefix}/UPDATE_PRICING_COMPONENTS`,
);

export const updatePricingComponents = makeApiActionCreatorV3(
  api.updatePricingComponents,
  UPDATE_PRICING_COMPONENTS[START],
  UPDATE_PRICING_COMPONENTS[SUCCESS],
  UPDATE_PRICING_COMPONENTS[ERROR],
);

export const UPDATE_COMPONENT_TYPES = createRequestTypes(
  `${prefix}/UPDATE_COMPONENT_TYPES`,
);

export const updateComponentTypes = makeApiActionCreatorV3(
  api.updateComponentTypes,
  UPDATE_COMPONENT_TYPES[START],
  UPDATE_COMPONENT_TYPES[SUCCESS],
  UPDATE_COMPONENT_TYPES[ERROR],
);

export const FETCH_PRICING_SCHEDULES = createRequestTypes(
  `${prefix}/FETCH_PRICING_SCHEDULES`,
);

export const fetchPricingSchedules = makeApiActionCreatorV3(
  api.fetchPricingSchedules,
  FETCH_PRICING_SCHEDULES[START],
  FETCH_PRICING_SCHEDULES[SUCCESS],
  FETCH_PRICING_SCHEDULES[ERROR],
);

export const FETCH_SCHEDULES = createRequestTypes(`${prefix}/FETCH_SCHEDULES`);

export const fetchSchedulesDetailPricing = makeApiActionCreatorV3(
  api.fetchSchedulesDetailPricing,
  FETCH_SCHEDULES[START],
  FETCH_SCHEDULES[SUCCESS],
  FETCH_SCHEDULES[ERROR],
);

export const fetchDetailedFixedIncrementAdjustments = makeApiActionCreatorV3(
  api.fetchDetailedFixedIncrementAdjustments,
  FETCH_SCHEDULES[START],
  FETCH_SCHEDULES[SUCCESS],
  FETCH_SCHEDULES[ERROR],
);

export const fetchSchedulesUnitCost = makeApiActionCreatorV3(
  api.fetchSchedulesUnitCost,
  FETCH_SCHEDULES[START],
  FETCH_SCHEDULES[SUCCESS],
  FETCH_SCHEDULES[ERROR],
);

export const fetchSchedulesIncrementCost = makeApiActionCreatorV3(
  api.fetchSchedulesIncrementCost,
  FETCH_SCHEDULES[START],
  FETCH_SCHEDULES[SUCCESS],
  FETCH_SCHEDULES[ERROR],
);

export const fetchSchedulesDepreciation = makeApiActionCreatorV3(
  api.fetchSchedulesDepreciation,
  FETCH_SCHEDULES[START],
  FETCH_SCHEDULES[SUCCESS],
  FETCH_SCHEDULES[ERROR],
);

export const INSERT_SCHEDULES = createRequestTypes(
  `${prefix}/INSERT_SCHEDULES`,
);

export const insertSchedulesDetailPricing = makeApiActionCreatorV3(
  api.insertSchedulesDetailPricing,
  INSERT_SCHEDULES[START],
  INSERT_SCHEDULES[SUCCESS],
  INSERT_SCHEDULES[ERROR],
);

export const insertDetailedFixedIncrementAdjustments = makeApiActionCreatorV3(
  api.insertDetailedFixedIncrementAdjustments,
  INSERT_SCHEDULES[START],
  INSERT_SCHEDULES[SUCCESS],
  INSERT_SCHEDULES[ERROR],
);

export const insertSchedulesUnitCost = makeApiActionCreatorV3(
  api.insertSchedulesUnitCost,
  INSERT_SCHEDULES[START],
  INSERT_SCHEDULES[SUCCESS],
  INSERT_SCHEDULES[ERROR],
);

export const insertSchedulesIncrementCost = makeApiActionCreatorV3(
  api.insertSchedulesIncrementCost,
  INSERT_SCHEDULES[START],
  INSERT_SCHEDULES[SUCCESS],
  INSERT_SCHEDULES[ERROR],
);

export const insertSchedulesDepreciation = makeApiActionCreatorV3(
  api.insertSchedulesDepreciation,
  INSERT_SCHEDULES[START],
  INSERT_SCHEDULES[SUCCESS],
  INSERT_SCHEDULES[ERROR],
);

export const DELETE_SCHEDULES_PRICING = createRequestTypes(
  `${prefix}/DELETE_SCHEDULES_PRICING`,
);

export const deleteSchedulesDetailPricing = makeApiActionCreatorV3(
  api.deleteSchedulesDetailPricing,
  DELETE_SCHEDULES_PRICING[START],
  DELETE_SCHEDULES_PRICING[SUCCESS],
  DELETE_SCHEDULES_PRICING[ERROR],
);

export const DELETE_DETAILED_FIXED_INCREMENT_ADJUSTMENTS = createRequestTypes(
  `${prefix}/DELETE_DETAILED_FIXED_INCREMENT_ADJUSTMENTS`,
);

export const deleteDetailedFixedIncrementAdjustments = makeApiActionCreatorV3(
  api.deleteDetailedFixedIncrementAdjustments,
  DELETE_DETAILED_FIXED_INCREMENT_ADJUSTMENTS[START],
  DELETE_DETAILED_FIXED_INCREMENT_ADJUSTMENTS[SUCCESS],
  DELETE_DETAILED_FIXED_INCREMENT_ADJUSTMENTS[ERROR],
);

export const DELETE_SCHEDULES_UNIT = createRequestTypes(
  `${prefix}/DELETE_SCHEDULES_UNIT`,
);

export const deleteSchedulesUnitCost = makeApiActionCreatorV3(
  api.deleteSchedulesUnitCost,
  DELETE_SCHEDULES_UNIT[START],
  DELETE_SCHEDULES_UNIT[SUCCESS],
  DELETE_SCHEDULES_UNIT[ERROR],
);

export const DELETE_SCHEDULES_INCREMENT = createRequestTypes(
  `${prefix}/DELETE_SCHEDULES_INCREMENT`,
);

export const deleteSchedulesIncrementCost = makeApiActionCreatorV3(
  api.deleteSchedulesIncrementCost,
  DELETE_SCHEDULES_INCREMENT[START],
  DELETE_SCHEDULES_INCREMENT[SUCCESS],
  DELETE_SCHEDULES_INCREMENT[ERROR],
);

export const DELETE_SCHEDULES_DEPRECIATION = createRequestTypes(
  `${prefix}/DELETE_SCHEDULES_DEPRECIATION`,
);

export const deleteSchedulesDepreciation = makeApiActionCreatorV3(
  api.deleteSchedulesDepreciation,
  DELETE_SCHEDULES_DEPRECIATION[START],
  DELETE_SCHEDULES_DEPRECIATION[SUCCESS],
  DELETE_SCHEDULES_DEPRECIATION[ERROR],
);

export const SET_SCHEDULES_ORDER = createRequestTypes(
  `${prefix}/SET_SCHEDULES_ORDER`,
);

export const setPricingOrder = makeApiActionCreatorV3(
  api.setPricingOrder,
  SET_SCHEDULES_ORDER[START],
  SET_SCHEDULES_ORDER[SUCCESS],
  SET_SCHEDULES_ORDER[ERROR],
);

export const FETCH_ALL_YEARS = createRequestTypes(`${prefix}/FETCH_ALL_YEARS`);

export const fetchAllYears = makeApiActionCreatorV3(
  pricingTableApi.fetchAllYears,
  FETCH_ALL_YEARS[START],
  FETCH_ALL_YEARS[SUCCESS],
  FETCH_ALL_YEARS[ERROR],
);

export const FETCH_MODELS = createRequestTypes(`${prefix}/FETCH_MODELS`);

export const fetchModels = makeApiActionCreatorV3(
  api.fetchModels,
  FETCH_MODELS[START],
  FETCH_MODELS[SUCCESS],
  FETCH_MODELS[ERROR],
);

export const DUPLICATE_MODEL = createRequestTypes(`${prefix}/DUPLICATE_MODEL`);

export const duplicateModel = makeApiActionCreatorV3(
  api.duplicateModel,
  DUPLICATE_MODEL[START],
  DUPLICATE_MODEL[SUCCESS],
  DUPLICATE_MODEL[ERROR],
);

export const INSERT_MODEL = createRequestTypes(`${prefix}/INSERT_MODEL`);

export const insertModel = makeApiActionCreatorV3(
  api.insertModel,
  INSERT_MODEL[START],
  INSERT_MODEL[SUCCESS],
  INSERT_MODEL[ERROR],
);

export const DELETE_MODEL = createRequestTypes(`${prefix}/DELETE_MODEL`);

export const deleteModel = makeApiActionCreatorV3(
  api.deleteModel,
  DELETE_MODEL[START],
  DELETE_MODEL[SUCCESS],
  DELETE_MODEL[ERROR],
);

export const SET_BASE_UNIT_COST_ADJUSTMENT = createRequestTypes(
  `${prefix}/SET_BASE_UNIT_COST_ADJUSTMENT`,
);

export const setBaseUnitCostAdjustment = makeApiActionCreatorV3(
  api.setBaseUnitCostAdjustment,
  SET_BASE_UNIT_COST_ADJUSTMENT[START],
  SET_BASE_UNIT_COST_ADJUSTMENT[SUCCESS],
  SET_BASE_UNIT_COST_ADJUSTMENT[ERROR],
);

export const FETCH_REVISION_HISTORY = createRequestTypes(
  `${prefix}/FETCH_REVISION_HISTORY`,
);

export const fetchRevisionHistory = makeApiActionCreatorV3(
  api.fetchRevisionHistory,
  FETCH_REVISION_HISTORY[START],
  FETCH_REVISION_HISTORY[SUCCESS],
  FETCH_REVISION_HISTORY[ERROR],
);